var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhotovoltaiquePanelV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 85,
    viewBox: "0 0 51 85",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6001 0.100105L0.100098 0.100105L0.100098 84.6001H50.6001L50.6001 0.100105Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 8.10035L1.10619 8.10054L0.100586 7.10414L0.100586 1.09693L1.10619 0.100536L7.10669 0.100349L8.10059 1.09675L8.10059 7.10396L7.10669 8.10035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 0.10054L1.95979 0.10054L1.95979 8.10054H2.07669L2.07669 0.10054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 0.100349L6.13609 0.100349L6.13609 8.10035H6.25308L6.25308 0.100349Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 8.10035L9.60619 8.10054L8.60059 7.10414V1.09693L9.60619 0.100536L15.6067 0.100349L16.6006 1.09675V7.10396L15.6067 8.10035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 0.10054L10.4598 0.10054L10.4598 8.10054H10.5767L10.5767 0.10054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 0.100349L14.6361 0.100349L14.6361 8.10035H14.7531L14.7531 0.100349Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 8.10035L18.1062 8.10054L17.1006 7.10414V1.09693L18.1062 0.100536L24.1067 0.100349L25.1006 1.09675V7.10396L24.1067 8.10035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 0.10054L18.9598 0.10054V8.10054H19.0767V0.10054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 0.100349L23.1361 0.100349V8.10035H23.2531V0.100349Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 8.10035L26.6062 8.10054L25.6006 7.10414V1.09693L26.6062 0.100536L32.6067 0.100349L33.6006 1.09675V7.10396L32.6067 8.10035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 0.10054L27.4598 0.10054V8.10054H27.5767V0.10054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 0.100349L31.6361 0.100349V8.10035H31.7531V0.100349Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 8.10035L35.1062 8.10054L34.1006 7.10414V1.09693L35.1062 0.100536L41.1067 0.100349L42.1006 1.09675V7.10396L41.1067 8.10035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 0.10054L35.9598 0.10054V8.10054H36.0767V0.10054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 0.100349L40.1361 0.100349V8.10035H40.2531V0.100349Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 8.10035L43.6062 8.10054L42.6006 7.10414V1.09693L43.6062 0.100536L49.6067 0.100349L50.6006 1.09675V7.10396L49.6067 8.10035Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 0.10054L44.4598 0.10054V8.10054H44.5767V0.10054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 0.100349L48.6361 0.100349V8.10035H48.7531V0.100349Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 16.6003L1.10619 16.6005L0.100586 15.6041L0.100586 9.59693L1.10619 8.60054L7.10669 8.60035L8.10059 9.59675L8.10059 15.6039L7.10669 16.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 8.60054H1.95979L1.95979 16.6005H2.07669L2.07669 8.60054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 8.60035H6.13609L6.13609 16.6003H6.25308L6.25308 8.60035Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 16.6003L9.60619 16.6005L8.60059 15.6041V9.59693L9.60619 8.60054L15.6067 8.60035L16.6006 9.59675V15.6039L15.6067 16.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 8.60054H10.4598L10.4598 16.6005H10.5767L10.5767 8.60054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 8.60035H14.6361L14.6361 16.6003H14.7531L14.7531 8.60035Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 16.6003L18.1062 16.6005L17.1006 15.6041V9.59693L18.1062 8.60054L24.1067 8.60035L25.1006 9.59675V15.6039L24.1067 16.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 8.60054H18.9598V16.6005H19.0767V8.60054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 8.60035H23.1361V16.6003H23.2531V8.60035Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 16.6003L26.6062 16.6005L25.6006 15.6041V9.59693L26.6062 8.60054L32.6067 8.60035L33.6006 9.59675V15.6039L32.6067 16.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 8.60054H27.4598V16.6005H27.5767V8.60054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 8.60035H31.6361V16.6003H31.7531V8.60035Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 16.6003L35.1062 16.6005L34.1006 15.6041V9.59693L35.1062 8.60054L41.1067 8.60035L42.1006 9.59675V15.6039L41.1067 16.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 8.60054H35.9598V16.6005H36.0767V8.60054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 8.60035H40.1361V16.6003H40.2531V8.60035Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 16.6003L43.6062 16.6005L42.6006 15.6041V9.59693L43.6062 8.60054L49.6067 8.60035L50.6006 9.59675V15.6039L49.6067 16.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 8.60054H44.4598L44.4598 16.6005H44.5767V8.60054Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 8.60035H48.6361V16.6003H48.7531V8.60035Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 25.1003L1.10619 25.1005L0.100586 24.1041L0.100586 18.0969L1.10619 17.1005L7.10669 17.1003L8.10059 18.0967L8.10059 24.1039L7.10669 25.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 17.1005H1.95979L1.95979 25.1005H2.07669L2.07669 17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 17.1003H6.13609L6.13609 25.1003H6.25308L6.25308 17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 25.1003L9.60619 25.1005L8.60059 24.1041V18.0969L9.60619 17.1005L15.6067 17.1003L16.6006 18.0967V24.1039L15.6067 25.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 17.1005H10.4598L10.4598 25.1005H10.5767L10.5767 17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 17.1003H14.6361L14.6361 25.1003H14.7531L14.7531 17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 25.1003L18.1062 25.1005L17.1006 24.1041V18.0969L18.1062 17.1005L24.1067 17.1003L25.1006 18.0967V24.1039L24.1067 25.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 17.1005H18.9598V25.1005H19.0767V17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 17.1003H23.1361V25.1003H23.2531V17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 25.1003L26.6062 25.1005L25.6006 24.1041V18.0969L26.6062 17.1005L32.6067 17.1003L33.6006 18.0967V24.1039L32.6067 25.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 17.1005H27.4598V25.1005H27.5767V17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 17.1003H31.6361V25.1003H31.7531V17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 25.1003L35.1062 25.1005L34.1006 24.1041V18.0969L35.1062 17.1005L41.1067 17.1003L42.1006 18.0967V24.1039L41.1067 25.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 17.1005H35.9598V25.1005H36.0767V17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 17.1003H40.1361V25.1003H40.2531V17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 25.1003L43.6062 25.1005L42.6006 24.1041V18.0969L43.6062 17.1005L49.6067 17.1003L50.6006 18.0967V24.1039L49.6067 25.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 17.1005H44.4598V25.1005H44.5767V17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 17.1003H48.6361V25.1003H48.7531V17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 33.6003L1.10619 33.6005L0.100586 32.6041L0.100586 26.5969L1.10619 25.6005L7.10669 25.6003L8.10059 26.5967L8.10059 32.6039L7.10669 33.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 25.6005H1.95979L1.95979 33.6005H2.07669L2.07669 25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 25.6003H6.13609L6.13609 33.6003H6.25308L6.25308 25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 33.6003L9.60619 33.6005L8.60059 32.6041V26.5969L9.60619 25.6005L15.6067 25.6003L16.6006 26.5967V32.6039L15.6067 33.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 25.6005H10.4598L10.4598 33.6005H10.5767L10.5767 25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 25.6003H14.6361L14.6361 33.6003H14.7531L14.7531 25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 33.6003L18.1062 33.6005L17.1006 32.6041V26.5969L18.1062 25.6005L24.1067 25.6003L25.1006 26.5967V32.6039L24.1067 33.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 25.6005H18.9598V33.6005H19.0767V25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 25.6003H23.1361V33.6003H23.2531V25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 33.6003L26.6062 33.6005L25.6006 32.6041V26.5969L26.6062 25.6005L32.6067 25.6003L33.6006 26.5967V32.6039L32.6067 33.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 25.6005H27.4598V33.6005H27.5767V25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 25.6003H31.6361V33.6003H31.7531V25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 33.6003L35.1062 33.6005L34.1006 32.6041V26.5969L35.1062 25.6005L41.1067 25.6003L42.1006 26.5967V32.6039L41.1067 33.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 25.6005H35.9598V33.6005H36.0767V25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 25.6003H40.1361V33.6003H40.2531V25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 33.6003L43.6062 33.6005L42.6006 32.6041V26.5969L43.6062 25.6005L49.6067 25.6003L50.6006 26.5967L50.6006 32.6039L49.6067 33.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 25.6005H44.4598V33.6005H44.5767V25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 25.6003H48.6361V33.6003H48.7531V25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 42.1003L1.10619 42.1005L0.100586 41.1041L0.100586 35.0969L1.10619 34.1005L7.10669 34.1003L8.10059 35.0967L8.10059 41.1039L7.10669 42.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 34.1005H1.95979L1.95979 42.1005H2.07669L2.07669 34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 34.1003H6.13609L6.13609 42.1003H6.25308L6.25308 34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 42.1003L9.60619 42.1005L8.60059 41.1041V35.0969L9.60619 34.1005L15.6067 34.1003L16.6006 35.0967V41.104L15.6067 42.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 34.1005H10.4598L10.4598 42.1005H10.5767L10.5767 34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 34.1003H14.6361L14.6361 42.1003H14.7531L14.7531 34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 42.1003L18.1062 42.1005L17.1006 41.1041V35.0969L18.1062 34.1005L24.1067 34.1003L25.1006 35.0967V41.104L24.1067 42.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 34.1005H18.9598V42.1005H19.0767V34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 34.1003H23.1361V42.1003H23.2531V34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 42.1003L26.6062 42.1005L25.6006 41.1041V35.0969L26.6062 34.1005L32.6067 34.1003L33.6006 35.0967V41.104L32.6067 42.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 34.1005H27.4598V42.1005H27.5767V34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 34.1003H31.6361V42.1003H31.7531V34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 42.1003L35.1062 42.1005L34.1006 41.1041V35.0969L35.1062 34.1005L41.1067 34.1003L42.1006 35.0967V41.104L41.1067 42.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 34.1005H35.9598V42.1005H36.0767V34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 34.1003H40.1361V42.1003H40.2531V34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 42.1003L43.6062 42.1005L42.6006 41.1041V35.0969L43.6062 34.1005L49.6067 34.1003L50.6006 35.0967L50.6006 41.104L49.6067 42.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 34.1005H44.4598V42.1005H44.5767V34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 34.1003H48.6361V42.1003H48.7531V34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 50.6003L1.10619 50.6005L0.100586 49.6041L0.100586 43.5969L1.10619 42.6005L7.10669 42.6003L8.10059 43.5967L8.10059 49.6039L7.10669 50.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 42.6005H1.95979L1.95979 50.6005H2.07669L2.07669 42.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 42.6003H6.13609L6.13609 50.6003H6.25308L6.25308 42.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 50.6003L9.60619 50.6005L8.60059 49.6041V43.5969L9.60619 42.6005L15.6067 42.6003L16.6006 43.5967V49.6039L15.6067 50.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 42.6005H10.4598L10.4598 50.6005H10.5767L10.5767 42.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 42.6003H14.6361L14.6361 50.6003H14.7531L14.7531 42.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 50.6003L18.1062 50.6005L17.1006 49.6041V43.5969L18.1062 42.6005L24.1067 42.6003L25.1006 43.5967V49.6039L24.1067 50.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 42.6005H18.9598V50.6005H19.0767V42.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 42.6003H23.1361V50.6003H23.2531V42.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 50.6003L26.6062 50.6005L25.6006 49.6041V43.5969L26.6062 42.6005L32.6067 42.6003L33.6006 43.5967V49.6039L32.6067 50.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 42.6005H27.4598V50.6005H27.5767V42.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 42.6003H31.6361V50.6003H31.7531V42.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 50.6003L35.1062 50.6005L34.1006 49.6041V43.5969L35.1062 42.6005L41.1067 42.6003L42.1006 43.5967V49.6039L41.1067 50.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 42.6005H35.9598V50.6005H36.0767V42.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 42.6003H40.1361V50.6003H40.2531V42.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 50.6003L43.6062 50.6005L42.6006 49.6041V43.5969L43.6062 42.6005L49.6067 42.6003L50.6006 43.5967L50.6006 49.6039L49.6067 50.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 42.6005H44.4598V50.6005H44.5767V42.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 42.6003H48.6361V50.6003H48.7531V42.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 59.1003L1.10619 59.1005L0.100586 58.1041L0.100586 52.0969L1.10619 51.1005L7.10669 51.1003L8.10059 52.0967L8.10059 58.1039L7.10669 59.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 51.1005H1.95979L1.95979 59.1005H2.07669L2.07669 51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 51.1003H6.13609L6.13609 59.1003H6.25308L6.25308 51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 59.1003L9.60619 59.1005L8.60059 58.1041V52.0969L9.60619 51.1005L15.6067 51.1003L16.6006 52.0967V58.1039L15.6067 59.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 51.1005H10.4598L10.4598 59.1005H10.5767L10.5767 51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 51.1003H14.6361L14.6361 59.1003H14.7531L14.7531 51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 59.1003L18.1062 59.1005L17.1006 58.1041V52.0969L18.1062 51.1005L24.1067 51.1003L25.1006 52.0967V58.1039L24.1067 59.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 51.1005H18.9598V59.1005H19.0767V51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 51.1003H23.1361V59.1003H23.2531V51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 59.1003L26.6062 59.1005L25.6006 58.1041V52.0969L26.6062 51.1005L32.6067 51.1003L33.6006 52.0967V58.1039L32.6067 59.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 51.1005H27.4598V59.1005H27.5767V51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 51.1003H31.6361V59.1003H31.7531V51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 59.1003L35.1062 59.1005L34.1006 58.1041V52.0969L35.1062 51.1005L41.1067 51.1003L42.1006 52.0967V58.1039L41.1067 59.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 51.1005H35.9598V59.1005H36.0767V51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 51.1003H40.1361V59.1003H40.2531V51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 59.1003L43.6062 59.1005L42.6006 58.1041V52.0969L43.6062 51.1005L49.6067 51.1003L50.6006 52.0967L50.6006 58.1039L49.6067 59.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 51.1005H44.4598V59.1005H44.5767V51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 51.1003H48.6361V59.1003H48.7531V51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 67.6003L1.10619 67.6005L0.100586 66.6041L0.100586 60.5969L1.10619 59.6005L7.10669 59.6003L8.10059 60.5967L8.10059 66.604L7.10669 67.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 59.6005H1.95979L1.95979 67.6005H2.07669L2.07669 59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 59.6003H6.13609L6.13609 67.6003H6.25308L6.25308 59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 67.6003L9.60619 67.6005L8.60059 66.6041V60.5969L9.60619 59.6005L15.6067 59.6003L16.6006 60.5967V66.604L15.6067 67.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 59.6005H10.4598L10.4598 67.6005H10.5767L10.5767 59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 59.6003H14.6361L14.6361 67.6003H14.7531L14.7531 59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 67.6003L18.1062 67.6005L17.1006 66.6041V60.5969L18.1062 59.6005L24.1067 59.6003L25.1006 60.5967V66.604L24.1067 67.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 59.6005H18.9598V67.6005H19.0767V59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 59.6003H23.1361V67.6003H23.2531V59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 67.6003L26.6062 67.6005L25.6006 66.6041V60.5969L26.6062 59.6005L32.6067 59.6003L33.6006 60.5967V66.604L32.6067 67.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 59.6005H27.4598V67.6005H27.5767V59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 59.6003H31.6361V67.6003H31.7531V59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 67.6003L35.1062 67.6005L34.1006 66.6041V60.5969L35.1062 59.6005L41.1067 59.6003L42.1006 60.5967V66.604L41.1067 67.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 59.6005H35.9598V67.6005H36.0767V59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 59.6003H40.1361V67.6003H40.2531V59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 67.6003L43.6062 67.6005L42.6006 66.6041V60.5969L43.6062 59.6005L49.6067 59.6003L50.6006 60.5967L50.6006 66.604L49.6067 67.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 59.6005H44.4598V67.6005H44.5767V59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 59.6003H48.6361V67.6003H48.7531V59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 76.1003L1.10619 76.1005L0.100586 75.1041L0.100586 69.0969L1.10619 68.1005L7.10669 68.1003L8.10059 69.0967L8.10059 75.104L7.10669 76.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 68.1005H1.95979L1.95979 76.1005H2.07669L2.07669 68.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 68.1003H6.13609L6.13609 76.1003H6.25308L6.25308 68.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 76.1003L9.60619 76.1005L8.60059 75.1041V69.0969L9.60619 68.1005L15.6067 68.1003L16.6006 69.0967V75.104L15.6067 76.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 68.1005H10.4598L10.4598 76.1005H10.5767L10.5767 68.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 68.1003H14.6361L14.6361 76.1003H14.7531L14.7531 68.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 76.1003L18.1062 76.1005L17.1006 75.1041V69.0969L18.1062 68.1005L24.1067 68.1003L25.1006 69.0967V75.104L24.1067 76.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 68.1005H18.9598V76.1005H19.0767V68.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 68.1003H23.1361V76.1003H23.2531V68.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 76.1003L26.6062 76.1005L25.6006 75.1041V69.0969L26.6062 68.1005L32.6067 68.1003L33.6006 69.0967V75.104L32.6067 76.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 68.1005H27.4598V76.1005H27.5767V68.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 68.1003H31.6361V76.1003H31.7531V68.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 76.1003L35.1062 76.1005L34.1006 75.1041V69.0969L35.1062 68.1005L41.1067 68.1003L42.1006 69.0967V75.104L41.1067 76.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 68.1005H35.9598V76.1005H36.0767V68.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 68.1003H40.1361V76.1003H40.2531V68.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 76.1003L43.6062 76.1005L42.6006 75.1041V69.0969L43.6062 68.1005L49.6067 68.1003L50.6006 69.0967L50.6006 75.104L49.6067 76.1003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 68.1005H44.4598V76.1005H44.5767V68.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 68.1003H48.6361V76.1003H48.7531V68.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10669 84.6003L1.10619 84.6005L0.100586 83.6041L0.100586 77.5969L1.10619 76.6005L7.10669 76.6003L8.10059 77.5967L8.10059 83.604L7.10669 84.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07669 76.6005H1.95979L1.95979 84.6005H2.07669L2.07669 76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25308 76.6003H6.13609L6.13609 84.6003H6.25308L6.25308 76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 84.6003L9.60619 84.6005L8.60059 83.6041V77.5969L9.60619 76.6005L15.6067 76.6003L16.6006 77.5967V83.604L15.6067 84.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 76.6005H10.4598L10.4598 84.6005H10.5767L10.5767 76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7531 76.6003H14.6361L14.6361 84.6003H14.7531L14.7531 76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 84.6003L18.1062 84.6005L17.1006 83.6041V77.5969L18.1062 76.6005L24.1067 76.6003L25.1006 77.5967V83.604L24.1067 84.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0767 76.6005H18.9598V84.6005H19.0767V76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 76.6003H23.1361V84.6003H23.2531V76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6067 84.6003L26.6062 84.6005L25.6006 83.6041V77.5969L26.6062 76.6005L32.6067 76.6003L33.6006 77.5967V83.604L32.6067 84.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5767 76.6005H27.4598V84.6005H27.5767V76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7531 76.6003H31.6361V84.6003H31.7531V76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1067 84.6003L35.1062 84.6005L34.1006 83.6041V77.5969L35.1062 76.6005L41.1067 76.6003L42.1006 77.5967V83.604L41.1067 84.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0767 76.6005H35.9598V84.6005H36.0767V76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2531 76.6003H40.1361V84.6003H40.2531V76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6067 84.6003L43.6062 84.6005L42.6006 83.6041V77.5969L43.6062 76.6005L49.6067 76.6003L50.6006 77.5967L50.6006 83.604L49.6067 84.6003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5767 76.6005H44.4598V84.6005H44.5767V76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7531 76.6003H48.6361V84.6003H48.7531V76.6003Z",
    fill: "#C9D1E8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotovoltaiquePanelV);
export default __webpack_public_path__ + "static/media/icon-photovoltaique-panel-v.6c131639a85f68bf21c6fef62f192137.svg";
export { ForwardRef as ReactComponent };